import React from "react";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface Props {
  onClose: () => void;
  handleOpenProposta: () => void;
  selectedItem: any;
  idLead: string | undefined;
  leadProducts: { label: string; value: string; idLeadCorretor: string };
  dataResumo: any;
  dataVincularCodigo: any;
}

const EscolherOpcaoModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header onClose={() => props?.onClose()} />
      <Footer
        handleOpenProposta={() => props?.handleOpenProposta()}
        selectedItem={props?.selectedItem}
        idLead={props?.idLead}
        leadProducts={props?.leadProducts}
        onClose={() => props?.onClose()}
        dataResumo={props?.dataResumo}
        dataVincularCodigo={props?.dataVincularCodigo}
      />
    </Styles.Container>
  );
};

export default EscolherOpcaoModal;
